// Período = 'YYYY-MM'. Es el formato único del panel para "un mes": el mismo que
// guardan los documentos de payrollPeriods, así que el mes puede viajar entre
// vistas y componentes como un solo string comparable, sin pares mes/año sueltos.

export const MONTHS = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
]

// { year, monthIndex } — monthIndex 0-11, listo para new Date(y, mi, …)
export function parsePeriod (period) {
  const [year, month] = String(period || '').split('-').map(Number)
  return { year, monthIndex: month - 1 }
}

export function toPeriod (year, monthIndex) {
  // new Date normaliza el desborde (mes 12 → enero del año siguiente)
  const d = new Date(year, monthIndex, 1)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}

// «Hoy» es siempre el día en Lima, no el del navegador: el negocio es peruano y
// el mes que se abre por defecto tiene que ser el mismo esté donde esté quien mira.
// Ojo: devuelve un Date con los CAMPOS de Lima y un epoch corrido, así que sólo
// vale para leer año/mes/día — nunca para comparar contra un instante real.
// (periodRange sigue armando los límites con la hora local del navegador.)
export function limaNow () {
  return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Lima' }))
}

export function currentPeriod () {
  const now = limaNow()
  return toPeriod(now.getFullYear(), now.getMonth())
}

export function shiftPeriod (period, delta) {
  const { year, monthIndex } = parsePeriod(period)
  return toPeriod(year, monthIndex + delta)
}

export function formatPeriod (period) {
  const { year, monthIndex } = parsePeriod(period)
  return `${MONTHS[monthIndex]} ${year}`
}

// Rango del mes en horas locales: día 1 a las 00:00:00 → último día a las 23:59:59.
// Los dos extremos son inclusivos, que es como se consultan deadline/dateOfIssue.
export function periodRange (period) {
  const { year, monthIndex } = parsePeriod(period)
  return {
    start: new Date(year, monthIndex, 1),
    end: new Date(year, monthIndex + 1, 0, 23, 59, 59)
  }
}

export function inPeriod (date, period) {
  if (!date) return false
  const d = date instanceof Date ? date : new Date(date)
  const { year, monthIndex } = parsePeriod(period)
  return d.getFullYear() === year && d.getMonth() === monthIndex
}
